import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(partnerId, username, password, admin, enabled) {
  return yield oncallFetch("/api/oncall/administration/partners/users/add", {
    partnerId,
    username,
    password,
    admin,
    enabled,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/administration/partners/users/add.js